/**
 * NOTE: Only works for preventing scrolling on desktop. There is presently
 * no good solution for mobile (but perhaps wouldn't be good mobile UX anyway).
 *
 * https://stackoverflow.com/questions/9538868/prevent-body-from-scrolling-when-a-modal-is-opened
 *
 * @returns {function()} Invoking the returned function restores scrolling.
 */
export default function preventDesktopScrolling() {
  const { style } = document.body;
  const previousValue = style.overflow;
  style.overflow = 'hidden';

  return () => {
    style.overflow = previousValue;
  };
}
